import '../../core/components/app-root/AppRoot.css';
import '../../core/styles/focusRingStatic.css';
import './panel.css';
import './Sidebar.css';
export var buttonContainer = '_zdcge95-3-15-1';
export var dismissButton = '_zdcge97-3-15-1 _zdcge96-3-15-1';
export var expandButton = '_zdcge98-3-15-1 _zdcge96-3-15-1';
export var hint = '_zdcge93-3-15-1 _z0fq9b4-3-15-1 _z0fq9bd-3-15-1 _z0fq9b6-3-15-1 _z0fq9bc-3-15-1';
export var integratedControls = '_zdcge91-3-15-1';
export var integratedControlsDrawerHeader = '_zdcge9a-3-15-1';
export var integratedControlsPanel = '_zdcge99-3-15-1';
export var sidebar = '_zdcge90-3-15-1';